<template>
    <v-dialog v-model="dialogSwitch" persistent scrollable width="850">
        <v-card>
            <v-card-title id="heading" class="d-flex justify-space-between">
                <div class="d-flex">
                    <h4>Service Task Logs: {{ task.vehicle_service_type }}</h4>
                </div>
                <v-btn density="compact" icon="mdi-close" variant="flat"
                       @click="$emit('update:modelValue', false)"/>
            </v-card-title>

            <v-container>
                <v-row>
                    <v-col cols="12">
                        <v-table>
                            <thead>
                            <tr>
                                <th>Odometer</th>
                                <th>Start Time</th>
                                <th>End Time</th>
                                <th>Notes</th>
                                <th>Status</th>
                                <th>Payment Type</th>
                                <th>Payment Last 4</th>
                                <th>Receipt ID</th>
                                <th>Total Cost</th>
                                <th>Tax</th>
                                <th>Grand Total</th>
                                <th>Created at</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr
                                v-for="log in logs"
                                v-if="!loading && logs.length"
                                class="text-left"
                            >
                                <td>{{ log.odometer ? strOperations().unitifyDistance(log.odometer, 'distance', 'km') : '' }}</td>
                                <td>{{ formatDateTime(log.start_time) }}</td>
                                <td>{{ formatDateTime(log.end_time) }}</td>
                                <td>{{ log.notes }}</td>
                                <td>{{ log.status_title }}</td>
                                <td>{{ log.driver_payment_type_name }}</td>
                                <td>{{ log.payment_last4 }}</td>
                                <td>{{ log.receipt_id }}</td>
                                <td>{{ log.total_cost }}</td>
                                <td>{{ log.tax }}</td>
                                <td>{{ log.grand_total }}</td>
                                <td>{{ formatDateTime(log.created_at) }}</td>
                            </tr>
                            <tr v-else>
                                <td v-if="loading" class="text-center" colspan="12">
                                    <v-progress-circular color="primary" indeterminate/>
                                </td>
                                <td v-else class="text-center" colspan="12">No record found</td>
                            </tr>
                            </tbody>
                        </v-table>
                    </v-col>
                </v-row>

                <v-row v-if="totalPages > 1" justify="center">
                    <v-col cols="8">
                        <v-pagination
                            v-model="currentPage"
                            :length="totalPages"
                            class="my-4"
                            density="compact"
                            @update:model-value="fetchServiceLogs"
                        ></v-pagination>
                    </v-col>
                </v-row>
            </v-container>

            <v-card-actions class="px-4 d-flex justify-end">
                <v-btn
                    size="small"
                    type="button"
                    @click="$emit('update:modelValue', false);"
                >
                    Close
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script setup>
import {ref, onMounted} from "vue";
import {send} from "@/composables/apiClient";
import {useSnackbarStore} from "@/stores/snackBarStore";
import {strOperations} from "@/composables/globals";
import {formatDateTime} from "@/composables/useTimezone";

const {showSnackbar} = useSnackbarStore();
const props = defineProps({
    modelValue: Boolean,
    task: Object,
});
const sortedType = ref(null);
const sortedColumn = ref(null);
const dialogSwitch = ref(props.modelValue);
const loading = ref(true);
const totalPages = ref(1);
const currentPage = ref(1);
const logs = ref([]);

const emits = defineEmits(["update:modelValue"]);
onMounted(() => {
    fetchServiceLogs();
});

const sort = (sorting) => {
    sortedColumn.value = sorting.column;
    sortedType.value = sorting.order;
    fetchServiceLogs();
}

const fetchServiceLogs = () => {
    loading.value = true;
    send("get", `fleet/service-tasks/${props.task.id}/logs?page=${currentPage.value}`)
        .then((response) => {
            logs.value = response.data.data.data;
            totalPages.value = response.data.data.meta.last_page;
            currentPage.value = response.data.data.meta.current_page;
        })
        .catch((error) => {
            console.log(error)
            showSnackbar(error.data.message ?? "Service logs could not be loaded", "error");
        }).finally(() => loading.value = false);
}
</script>
